var _g, _g2, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBannerConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1077_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8802 15.0105C39.9145 16.8021 39.9145 19.2072 39.9145 24.0176C39.9145 28.828 39.9145 31.2331 38.8802 33.0246C38.2026 34.1983 37.228 35.1729 36.0543 35.8505C34.2628 36.8848 31.8577 36.8848 27.0473 36.8848H21.9004C20.8456 36.8848 20.3182 36.8848 19.8776 36.9252C18.6875 37.0345 17.6895 37.3084 16.6103 37.8219C16.2109 38.012 15.7868 38.2637 14.9388 38.7671L12.9046 39.9746C12.3631 40.296 11.6853 39.8688 11.7415 39.2417L11.818 38.3893C11.9894 36.4798 11.0261 34.6849 10.0675 33.0246C9.0332 31.2331 9.0332 28.828 9.0332 24.0176C9.0332 19.2072 9.0332 16.8021 10.0675 15.0106C10.7451 13.8369 11.7197 12.8623 12.8934 12.1847C14.6849 11.1504 17.09 11.1504 21.9004 11.1504L27.0473 11.1504C31.8577 11.1504 34.2628 11.1504 36.0543 12.1847C37.228 12.8623 38.2026 13.8369 38.8802 15.0105Z",
    fill: "url(#paint0_linear_1077_1565)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5585 15.1963C39.0375 16.0261 39.2883 17.0148 39.4152 18.4155C39.5427 19.8214 39.543 21.6056 39.543 24.0176C39.543 26.4296 39.5427 28.2138 39.4152 29.6197C39.2883 31.0204 39.0375 32.0091 38.5585 32.8389C37.9135 33.9561 36.9858 34.8838 35.8686 35.5288C35.0388 36.0078 34.0501 36.2586 32.6494 36.3855C31.2435 36.513 29.4593 36.5133 27.0473 36.5133H21.9004H21.8717C20.8438 36.5133 20.3012 36.5133 19.8437 36.5553C18.6099 36.6686 17.5694 36.9541 16.4507 37.4865C16.0358 37.6839 15.5984 37.9435 14.7713 38.4345L14.7492 38.4476L12.7149 39.6551C12.434 39.8219 12.0823 39.6003 12.1115 39.2749L12.188 38.4225C12.3714 36.3791 11.3398 34.4853 10.3893 32.8389C9.91017 32.0091 9.65942 31.0204 9.53247 29.6197C9.40505 28.2138 9.40469 26.4296 9.40469 24.0176C9.40469 21.6056 9.40505 19.8214 9.53247 18.4155C9.65942 17.0148 9.91017 16.0261 10.3892 15.1963C11.0342 14.0791 11.9619 13.1514 13.0791 12.5064C13.9089 12.0274 14.8976 11.7766 16.2983 11.6497C17.7042 11.5222 19.4884 11.5219 21.9004 11.5219L27.0473 11.5219C29.4593 11.5219 31.2435 11.5222 32.6494 11.6497C34.0501 11.7766 35.0388 12.0274 35.8686 12.5064C36.9858 13.1514 37.9135 14.0791 38.5585 15.1963Z",
    stroke: "white",
    strokeOpacity: 0.26,
    strokeWidth: 0.742977
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.44461,
    y: 4.98953,
    width: 58.644,
    height: 56.6786
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.94px)",
      clipPath: "url(#bgblur_0_1077_1565_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1077_1565)",
    "data-figma-bg-blur-radius": 13.8816
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3605 22.7313C19.3262 24.5228 19.3262 26.9279 19.3262 31.7383C19.3262 36.5487 19.3262 38.9538 20.3605 40.7453C21.0381 41.919 22.0127 42.8936 23.1863 43.5712C24.9778 44.6055 27.383 44.6055 32.1934 44.6055H37.3403C38.5902 44.6055 39.2152 44.6055 39.7407 44.6658C40.7679 44.7836 41.617 45.0211 42.5561 45.4535C43.0366 45.6746 43.5381 45.9791 44.5411 46.588L46.328 47.6728C46.8693 48.0014 47.5542 47.5745 47.4976 46.9438L47.4227 46.1098C47.2514 44.2004 48.2146 42.4056 49.1731 40.7453C50.2075 38.9538 50.2075 36.5487 50.2075 31.7383C50.2075 26.9279 50.2075 24.5228 49.1731 22.7313C48.4955 21.5576 47.5209 20.583 46.3473 19.9054C44.5558 18.8711 42.1506 18.8711 37.3403 18.8711L32.1934 18.8711C27.383 18.8711 24.9778 18.8711 23.1863 19.9054C22.0127 20.583 21.0381 21.5576 20.3605 22.7313Z",
    fill: "url(#paint1_linear_1077_1565)",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7889 31.7383C19.7889 29.3246 19.7893 27.5453 19.9163 26.1445C20.0427 24.75 20.2915 23.7762 20.7612 22.9626C21.3982 21.8593 22.3144 20.9431 23.4177 20.3061C24.2313 19.8364 25.2051 19.5876 26.5996 19.4612C28.0003 19.3343 29.7797 19.3338 32.1934 19.3338L37.3403 19.3338C39.754 19.3338 41.5333 19.3343 42.9341 19.4612C44.3285 19.5876 45.3024 19.8364 46.116 20.3061C47.2192 20.9431 48.1354 21.8593 48.7724 22.9626C49.2421 23.7762 49.491 24.75 49.6173 26.1445C49.7443 27.5453 49.7448 29.3246 49.7448 31.7383C49.7448 34.152 49.7443 35.9313 49.6173 37.3321C49.491 38.7266 49.2421 39.7004 48.7724 40.514C47.8238 42.157 46.7755 44.075 46.9618 46.1511L47.0367 46.9852C47.0594 47.2379 46.785 47.4089 46.5681 47.2772L44.7812 46.1925L44.7479 46.1722C43.7764 45.5824 43.2542 45.2654 42.7496 45.0331C41.7659 44.5803 40.8693 44.3295 39.7935 44.2061C39.2416 44.1428 38.5927 44.1428 37.3832 44.1428H37.3403H32.1934C29.7797 44.1428 28.0003 44.1423 26.5995 44.0154C25.2051 43.889 24.2313 43.6402 23.4177 43.1705C22.3144 42.5335 21.3982 41.6173 20.7612 40.514C20.2915 39.7004 20.0427 38.7266 19.9163 37.3321C19.7893 35.9313 19.7889 34.152 19.7889 31.7383Z",
    stroke: "url(#paint2_linear_1077_1565)",
    strokeOpacity: 0.29,
    strokeWidth: 0.925437,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.7842,
    y: 26.6045,
    width: 2.62355,
    height: 15.7413,
    rx: 1.31177,
    transform: "rotate(90 42.7842 26.6045)",
    fill: "url(#paint3_linear_1077_1565)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1094,
    y: 34.3262,
    width: 2.8957,
    height: 12.0654,
    rx: 1.44785,
    transform: "rotate(90 39.1094 34.3262)",
    fill: "url(#paint4_linear_1077_1565)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1077_1565",
    x: 5.50815,
    y: 9.33101,
    width: 37.931,
    height: 35.9842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.70567
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76252
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.341176 0 0 0 0 0.576471 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1077_1565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1077_1565",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13711
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.0468
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1077_1565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1077_1565",
    x: 5.44461,
    y: 4.98953,
    width: 58.644,
    height: 56.6786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.38816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.72489
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.529412 0 0 0 0 0.980392 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1077_1565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1077_1565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1077_1565_clip_path",
    transform: "translate(-5.44461 -4.98953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3605 22.7313C19.3262 24.5228 19.3262 26.9279 19.3262 31.7383C19.3262 36.5487 19.3262 38.9538 20.3605 40.7453C21.0381 41.919 22.0127 42.8936 23.1863 43.5712C24.9778 44.6055 27.383 44.6055 32.1934 44.6055H37.3403C38.5902 44.6055 39.2152 44.6055 39.7407 44.6658C40.7679 44.7836 41.617 45.0211 42.5561 45.4535C43.0366 45.6746 43.5381 45.9791 44.5411 46.588L46.328 47.6728C46.8693 48.0014 47.5542 47.5745 47.4976 46.9438L47.4227 46.1098C47.2514 44.2004 48.2146 42.4056 49.1731 40.7453C50.2075 38.9538 50.2075 36.5487 50.2075 31.7383C50.2075 26.9279 50.2075 24.5228 49.1731 22.7313C48.4955 21.5576 47.5209 20.583 46.3473 19.9054C44.5558 18.8711 42.1506 18.8711 37.3403 18.8711L32.1934 18.8711C27.383 18.8711 24.9778 18.8711 23.1863 19.9054C22.0127 20.583 21.0381 21.5576 20.3605 22.7313Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1077_1565",
    x1: 10.7842,
    y1: 11.9771,
    x2: 26.2068,
    y2: 45.4536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF76AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666658,
    stopColor: "#DC2169"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1077_1565",
    x1: 34.7668,
    y1: 18.8711,
    x2: 34.7668,
    y2: 47.7865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1077_1565",
    x1: 34.7668,
    y1: 18.8711,
    x2: 34.7668,
    y2: 47.7865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1077_1565",
    x1: 44.096,
    y1: 26.6045,
    x2: 44.096,
    y2: 42.3458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1077_1565",
    x1: 40.5572,
    y1: 34.3262,
    x2: 40.5572,
    y2: 46.3916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E6E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBannerConsulting);
export default __webpack_public_path__ + "static/media/icon_banner_consulting.f0e4fc3b750052c81fe87d68c24ad824.svg";
export { ForwardRef as ReactComponent };